import { render, staticRenderFns } from "./ManageRequestsList.vue?vue&type=template&id=791704ae&scoped=true&"
import script from "./ManageRequestsList.vue?vue&type=script&lang=js&"
export * from "./ManageRequestsList.vue?vue&type=script&lang=js&"
import style0 from "./ManageRequestsList.vue?vue&type=style&index=0&id=791704ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791704ae",
  null
  
)

export default component.exports